// extracted by mini-css-extract-plugin
module.exports = {"container":"EbsCustomAlert_container__2QCf9","largeRadius":"EbsCustomAlert_largeRadius__3XKa-","smallFont":"EbsCustomAlert_smallFont__1BXky","large":"EbsCustomAlert_large__3t_xh"};